import {queryOptions} from '@tanstack/react-query'

import {fetchMe, UnauthorizedError} from './auth-api'
import type {AuthUser} from './types'

export const meQueryKey = ['auth', 'me'] as const

export const meQueryOptions = queryOptions({
    queryKey: meQueryKey,
    queryFn: async (): Promise<AuthUser | null> => {
        try {
            return await fetchMe()
        } catch (error) {
            if (error instanceof UnauthorizedError) {
                return null
            }
            throw error
        }
    },
    staleTime: Infinity,
    retry: false,
})
